import btoa from 'btoa';
import { AppliedFilters } from '~/services/common/contracts';

const generateSearchLinkFilter = (
  { filters }: { filters?: AppliedFilters },
  zip5 = ''
) => {
  let searchLink = '';

  if (filters) {
    const url = new URL('/cars/filters', 'https://www.dummy.com');
    url.searchParams.set(
      'cvnaid',
      btoa(JSON.stringify({ ...(zip5 !== '' && { zip5 }), filters }))
    );

    return url.pathname + url.search;
  }

  return searchLink;
};

export default generateSearchLinkFilter;
